/** Sitewide product name and tagline (footers, default Helmet titles, OG fallbacks). */
export const BRAND_TITLE = 'Solt | Eats, places & foodies';
export const BRAND_TAGLINE = 'Eats, places & foodies';
